"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var NoteHelper_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteHelper = exports.Resources = exports.GlobalEvents = exports.MainStage = void 0;
const GameEvent_1 = require("../Common/GameEvent");
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const GameConfig_1 = require("../Core/GameConfig");
const Projection_1 = require("../Core/Projection");
const Constants_1 = require("../Core/Constants");
class MainStage extends pixi_js_1.Container {
}
exports.MainStage = MainStage;
class GlobalEvents {
    constructor() {
        /** delta, time in seconds */
        this.Update = new GameEvent_1.GameEvent();
        /** width, height */
        this.Resize = new GameEvent_1.GameEvent();
        this.WindowBlur = new GameEvent_1.GameEvent();
        this.WindowFocus = new GameEvent_1.GameEvent();
        this.End = new GameEvent_1.GameEvent();
    }
}
exports.GlobalEvents = GlobalEvents;
class Resources {
}
exports.Resources = Resources;
let NoteHelper = NoteHelper_1 = class NoteHelper {
    constructor(config) {
        this.staytime = GameConfig_1.staytime(config.speed);
        this.noteScale = NoteHelper_1.noteInitScale * config.noteScale;
    }
    /** pre-multiplied config note scale */
    calc(note, musicTime) {
        const dt = musicTime - note.time;
        const t = dt / this.staytime;
        return Projection_1.projection(t, Constants_1.LaneCenterXs[note.lane]);
    }
    setScale(note, scale) {
        note.scale.set(scale * this.noteScale);
    }
};
NoteHelper.noteInitScale = 0.7;
NoteHelper = NoteHelper_1 = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameConfig_1.GameConfig])
], NoteHelper);
exports.NoteHelper = NoteHelper;
//# sourceMappingURL=SymbolClasses.js.map